import React from "react";
import UpdateProjectForm from "./updateProjectForm";

// Components
import PageTitle from "../../components/base/PageTitle";
import BreadCrumb from "../../components/base/BreadCrump";

const ProjectEdit = props => {
  const breadcrumbList = [
    { label: "Home", link: "/dashboard" },
    {
      label: "Projects",
      link: "/projects"
    },
    {
      label: "Edit Project",
      link: ""
    }
  ];
  return (
    <div className="flex-1">
      <BreadCrumb list={breadcrumbList} />
      <PageTitle label="Edit Project" />
      <UpdateProjectForm history={props.history} match={props.match} />
    </div>
  );
};

export default ProjectEdit;
